import { useQuery } from 'convex/react';
import { useAuth } from '@clerk/clerk-react';
import { api } from '../convex';

/**
 * Hook for Convex authentication operations
 * RULES OF HOOKS COMPLIANT: No hooks inside try-catch, no conditional hooks
 */
const useConvexAuth = () => {
  const { isSignedIn } = useAuth();

  // Always called unconditionally; use "skip" to prevent execution
  const userProfile = useQuery(api.auth.getUserProfile, isSignedIn ? {} : "skip");
  const authStatus  = useQuery(api.auth.me, isSignedIn ? {} : "skip");

  return {
    userProfile,
    profileLoading: userProfile === undefined && isSignedIn,
    authStatus,
    authLoading: authStatus === undefined,
    authenticated: authStatus?.authenticated || false,
    createSession: async () => {
      throw new Error('createSession is deprecated. Use Clerk authentication.');
    },
    isAuthenticated: () => authStatus?.authenticated || false,
    getUserId: () => authStatus?.subject || null,
  };
};

export default useConvexAuth;
